import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

import { RelatedPostsComponent } from './components/related-posts/related-posts.component'

import { ClubsPostsModule } from '@alliance/clubs/posts'

import { SharedTranslationModule } from '@alliance/shared/translation'

@NgModule({
  imports: [CommonModule, RouterModule, ClubsPostsModule, SharedTranslationModule],
  declarations: [RelatedPostsComponent],
  exports: [RelatedPostsComponent]
})
export class ClubsRelatedPostsModule {}
